// const i18n = require("../../config/i18n")
import browserLang from "browser-lang"
import { navigate } from "gatsby"

const locales = require("../../config/i18n")

export function redirectToUserLanguage() {
  if (typeof window !== "undefined") {
    const browserUserLang = browserLang()
      .toLowerCase()
      .slice(0, 2)

    // if user doesn't have a lang defined in localstorage yet
    if (!window.sessionStorage.getItem("userPreferedLang")) {
      Object.keys(locales).map(lang => {
        const localeLang = lang.slice(0, 2)
        let defaultAppLang = undefined

        window.sessionStorage.setItem("userPreferedLang", browserUserLang)

        if (locales[lang].default === true) {
          defaultAppLang = locales[lang].path
        }

        // if browserLang is available in locales -> redirect
        if (localeLang === browserUserLang) {
          // console.log(
          //   "localeLang match browserlang " + localeLang + " " + defaultAppLang
          // )
          // if equals default redirect to "/" (/defaultLang do not exist)
          // TODO redirect to same page
          localeLang === defaultAppLang
            ? navigate("/")
            : navigate("/" + localeLang)
        }
        return true
      })
      // browserUserLang do not match any known lang, redirect to default
      navigate("/")
    }
  }
}

export function isExternalLink(link) {
  if (link === null) return false
  return link._linkType === "Link.web" ? true : false
}
export function isDocumentLink(link) {
  if (link === null) return false
  return link._linkType === "Link.document" ? true : false
}

export const regEmail = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
